export default "__VITE_ASSET__Ch_L80u9__"